function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoStacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 274,
    viewBox: "0 0 274 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.976929,
    y: 0.843018,
    width: 273,
    height: 273,
    rx: 136.5,
    fill: "#FC6432",
    style: {
      fill: "#FC6432",
      fill: "color(display-p3 0.9882 0.3922 0.1961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.704 114.66C160.205 113.803 160.276 112.731 160.847 111.874L184.68 76.5107C185.323 75.5106 185.394 74.2961 184.823 73.2959C184.252 72.2243 183.182 71.6527 182.04 71.6527H172.764C171.765 71.6527 170.766 72.1528 170.123 73.0816L142.294 114.518C141.58 115.589 140.438 116.161 139.154 116.161H135.657C134.373 116.161 133.231 115.518 132.518 114.518L104.831 73.0101C104.26 72.0814 103.189 71.5813 102.19 71.5813H92.9137C91.772 71.5813 90.6302 72.2243 90.1307 73.2959C89.5598 74.3675 89.7026 75.582 90.2734 76.5107L114.107 111.946C114.678 112.731 114.749 113.803 114.25 114.66C113.75 115.589 112.894 116.089 111.895 116.089H75.4309C73.6469 116.089 72.2911 117.518 72.2911 119.233V126.948C72.2911 128.734 73.7183 130.092 75.4309 130.092H199.523C201.307 130.092 202.663 128.663 202.663 126.948V119.233C202.663 117.589 201.45 116.304 199.88 116.089C199.737 116.089 199.594 116.089 199.452 116.089H163.059C162.06 116.089 161.132 115.589 160.704 114.66ZM132.589 160.168L104.759 201.604C104.188 202.533 103.118 203.033 102.119 203.033H92.8423C91.7006 203.033 90.6302 202.39 90.0594 201.39C89.4885 200.39 89.5598 199.104 90.2021 198.175L113.964 162.812C114.535 161.955 114.607 160.954 114.107 160.026C113.608 159.168 112.751 158.597 111.752 158.597H75.4309C73.7183 158.597 72.2911 157.239 72.2911 155.453V147.738C72.2911 146.023 73.6469 144.594 75.4309 144.594H199.238C199.238 144.594 199.452 144.594 199.523 144.594C201.236 144.594 202.663 145.952 202.663 147.738V155.453C202.663 157.168 201.307 158.597 199.523 158.597H163.13C162.06 158.597 161.204 159.097 160.775 160.026C160.276 160.954 160.347 161.955 160.918 162.74L184.752 198.175C185.323 199.104 185.465 200.318 184.895 201.39C184.324 202.462 183.253 203.105 182.112 203.105H172.835C171.765 203.105 170.837 202.605 170.266 201.747L142.436 160.311C141.723 159.24 140.581 158.668 139.297 158.668H135.8C134.516 158.668 133.374 159.311 132.66 160.311L132.589 160.168Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStacks);
export default __webpack_public_path__ + "static/media/logo-stacks.f13d74ffd77217bc4ef14e2bd7b34753.svg";
export { ForwardRef as ReactComponent };